import styled from 'styled-components';
import { KOALA } from 'HubStyleTokens/colors';
export const StyledGoogleOAuthButton = styled.div.withConfig({
  displayName: "GoogleOAuthButtonstyles__StyledGoogleOAuthButton",
  componentId: "choey-0"
})(["", " height:40px;", ""], props => props.shouldCenter && `display: flex;
  justify-content: center;`, props => `padding:${props.isAssignedToACQ143Variant ? '2px 1.2rem 2px 0' : '2px 1rem'} ;`);
export const StyledGoogleIdentityServicesLoading = styled.div.withConfig({
  displayName: "GoogleOAuthButtonstyles__StyledGoogleIdentityServicesLoading",
  componentId: "choey-1"
})(["height:40px;background:", ";"], KOALA);
export const StyledGoogleIdentityServicesLoadingContainer = styled.div.withConfig({
  displayName: "GoogleOAuthButtonstyles__StyledGoogleIdentityServicesLoadingContainer",
  componentId: "choey-2"
})(["display:flex;justify-content:center;"]);